<mat-sidenav-container fxFlex="100">
  <mat-sidenav #sidenav mode="side" [(opened)]="opened" class="p-20">
    <h3>{{'FOCUS.REACTIVOS.STEPS.1.DISPONIBLES' | translate}}</h3>
    <!-- <mat-action-list>
      <button mat-list-item *ngFor="let plantilla of plantillas;let i = index;" (click)="eligePlantilla(plantilla,i)" class="botonPlantilla" [ngClass]="{'seleccionado': numPlantilla === i}">
        {{plantilla.nombrePlantilla}}
      </button>
    </mat-action-list> -->
    <mat-button-toggle-group name="botonesPlantillas" vertical style="overflow:visible">
      <mat-button-toggle *ngFor="let plantilla of plantillas;let i = index;" (click)="eligePlantilla(plantilla,i)" class="botonPlantilla">{{plantilla.nombrePlantilla}}</mat-button-toggle>
    </mat-button-toggle-group>
  </mat-sidenav>

  <mat-sidenav-content class="p-20" >
    <ng-container *ngIf="plantillaElegida; else sinElegida" >
      <h3>{{'FOCUS.REACTIVOS.STEPS.1.LISTADO.PICKEDTITU' | translate}} <b>{{plantillaElegida.nombrePlantilla}}</b></h3>

      <ng-container *ngIf="cargando; else cargaCompleta">
        <div fxLayout="column" fxLayoutAlign="space-between center" class="pt-40">
          <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
          <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
        </div>
      </ng-container>

      <ng-template #cargaCompleta>
        <div class="" fxLayout="row" fxLayoutAlign="space-between stretch">
          <p>{{'FOCUS.REACTIVOS.STEPS.1.LISTADO.PICKEDTOT' | translate}} {{reactivosNativo.length}}</p>
          <p>{{'FOCUS.REACTIVOS.STEPS.1.LISTADO.PICKEDNUM' | translate}} {{reactivosSel.selectedOptions.selected.length}}</p>
        </div>
        <mat-selection-list #reactivosSel (selectionChange)="guardaReactivo($event)" style="width:90%" >
          <mat-list-option *ngFor="let reactivo of reactivosNativo; last as last" [value]="reactivo" [selected]="reactivo.guardado" [disabled]="pasoCompleto">
            {{reactivo.pregunta}}
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-option>
        </mat-selection-list>
      </ng-template>

    </ng-container>
    <ng-template #sinElegida>
      <h3>{{'FOCUS.REACTIVOS.STEPS.1.LISTADO.TITULO' | translate}}</h3>
      <h3>{{'FOCUS.REACTIVOS.STEPS.1.LISTADO.SUBTITULO' | translate}}</h3>
    </ng-template>
  </mat-sidenav-content>
</mat-sidenav-container>
